<template>
    <section>
        <div class="banner_box">
            <img src="../../assets/applyUse/sqsys.png" alt="">
        </div>
        <div class="step_box">
            <div class="center_box">
                <div class="step">
                    <div class="step_img">
                        <img src="../../assets/applyUse/03.jpg" alt="">
                    </div>
                    <div class="step_content">
                        <p>申请试用</p>
                        <div>填写油站基本信息，提交申请。</div>
                    </div>
                </div>
                <div class="step">
                    <div class="step_img">
                        <img src="../../assets/applyUse/02.jpg" alt="">
                    </div>
                    <div class="step_content">
                        <p>细节沟通</p>
                        <div>我们收到您的申请后会有专人第一时间与您取得联系，进行细节沟通。</div>
                    </div>
                </div>
                <div class="step">
                    <div class="step_img">
                        <img src="../../assets/applyUse/01.jpg" alt="">
                    </div>
                    <div class="step_content">
                        <p>开通账号</p>
                        <div>确定意向后双方签署正式合作协议，并按照流程付款和开票。</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 表单 -->
        <div class="form_box">
            <div class="form" id="form">
                <p class="form_title">表单填写</p>

                <Form ref="form" :model="form" :rules="rule" label-position="left" :label-width="100">
                    <Row>
                        <Col span="10" offset="1">
                            <FormItem label="姓名" prop="name">
                                <Input v-model.trim="form.name" placeholder="请输入姓名"></Input>
                            </FormItem>
                            <FormItem label="手机号" prop="phone">
                                <Input v-model.trim="form.phone" placeholder="请输入手机号"></Input>
                            </FormItem>
                            <FormItem label="油站名称" prop="stationName">
                                <Input v-model.trim="form.stationName" placeholder="请输入油站名称"></Input>
                            </FormItem>
                        </Col>
                        <Col span="10" offset="2">
                            <FormItem label="油站类型" prop="stationType">
                                <Select v-model="form.stationType">
                                    <Option value="company">集团</Option>
                                    <Option value="store">单站</Option>
                                </Select>
                            </FormItem>
                            <FormItem label="油站公众号" prop="wechat">
                                <Select v-model="form.wechat">
                                    <Option value="1">有</Option>
                                    <Option value="0">无</Option>
                                </Select>
                            </FormItem>
                            <FormItem label="所在省市" prop="area">
                                <Input v-model.trim="form.area"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
                <Button type="primary" shape="circle" @click="submit" style="width: 200px;">免费试用</Button>
                <p class="remarks">提交后3个工作日内我们会与您联系</p>
            </div>
        </div>
    </section>
</template>
<script>

    export default {
        data() {
            const validateName = (rule, value, callback) => {

                if (value === '') {
                    callback(new Error('输入内容不能为空'));
                } else {
                    callback();
                }
            };
            return {
                form: {
                    name: '',
                    phone: '',
                    stationName: '',
                    stationType: '',
                    wechat: '',
                    area: ''
                },
                rule: {
                    name: [
                        // { required: true, message: '请输入姓名', trigger: 'blur' },
                        {required: true, validator: validateName, trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, validator: validateName, trigger: 'blur'}
                    ],
                    stationName: [
                        {required: true, validator: validateName, trigger: 'blur'}
                    ],
                    // stationType: [
                    //     { required: true, message: '请选择油站类型', trigger: 'blur' }
                    // ],
                    // wechat: [
                    //     { required: true, message: '请选择油站公众号', trigger: 'blur' }
                    // ],
                    // area: [
                    //     {required: true, validator: validateName, trigger: 'blur'}
                    // ]
                }
            }
        },
        methods: {
            submit(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        axios.post('/icc/save',this.form)
                        .then((res) => {
                            if(res.data.code=='0'){
                                this.$Message.success(res.data.msg);
                                this.form = {
                                    name: '',
                                    phone: '',
                                    stationName: '',
                                    stationType: '',
                                    wechat: '',
                                    area: ''
                                };
                            }else{
                                this.$Message.warning(res.data.msg);
                            }
                        }).catch((error) => {
                            this.$Message.warning(error);
                        });
                    } else {
                        this.$Message.warning('请输入完整信息！');
                    }
                })
            }
        },
    }
</script>
<style scoped>
    .banner_box img{
        width: 100%;
        vertical-align: bottom;
    }
    /* 步骤 */
    .step_box{
        padding: 64px 0;
    }
    .center_box{
        width: 1200px;
        margin: 0 auto;
    }
    .step{
        display: inline-block;
        position: relative;
        vertical-align: top;
        margin-right: 24px;
        width: 384px;
        height: 236px;
    }
    .step:last-child{
        margin-right: 0;
    }
    .step_img img{
        vertical-align: bottom;
    }
    .step_content{
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        text-align: left;
        padding: 90px 40px;
    }
    .step_content p{
        font-size: 16px;
        margin-bottom: 20px;
    }
    .step_content div{
        font-size: 14px;
    }
    /* 表单 */
    .form_box{
        height: 588px;
        background-image: url(../../assets/applyUse/biaodan_bg.jpg);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding-top: 90px;
    }
    .form{
        width: 1200px;
        background-color: #fff;
        height: 400px;
        margin: 0 auto;
        padding: 52px 70px;
    }
    .form_title{
        font-size: 30px;
        margin-bottom: 24px;
    }
    .remarks{
        color: #999;
        font-size: 14px;
        padding-top: 12px;
    }
</style>
